"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("monday-ui-style/dist/index.min.css");
